import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyA5srjmG4QgWTc5lzwTNujcem6ug61GRrQ",
  authDomain: "bidsense-dashboard.firebaseapp.com",
  projectId: "bidsense-dashboard",
  storageBucket: "bidsense-dashboard.firebasestorage.app",
  messagingSenderId: "913213353870",
  appId: "1:913213353870:web:c611146e3b91c7d9e53edf"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();